import React, { useContext } from 'react';
import { CustomerContext } from './Customer'
import { ShopContext } from './Shop'
import { EnrollmentsContext } from './Enrollments'
import OfficeHourSubscription from '../models/OfficeHourSubscription'
import { SubscriptionCodesContext } from './SubscriptionCodes'
import { OfficeHoursContext } from './OfficeHours'
import { LineItemsContext } from './LineItems'

const OfficeHourSubscriptionsContext = React.createContext();

const OfficeHourSubscriptionsProvider = (props) => {
  const [customer] = useContext(CustomerContext);
  const shop_name = useContext(ShopContext);
  const subscriptionCodes = useContext(SubscriptionCodesContext)
  const [officeHours] = useContext(OfficeHoursContext)
  const lineItems = useContext(LineItemsContext)

  const [enrollments] = useContext(EnrollmentsContext)
  const enrollmentsDupe = [].concat(enrollments)

  let officeHourCountWithoutEnrollment = 0;

  let officeHourSubscriptions = lineItems.map((lineItem) => {
    const enrollment = enrollmentsDupe.find((enrollment) => {
      return lineItem.matches(enrollment)
    })
    if (!enrollment) {
      officeHourCountWithoutEnrollment++
    } else {
      // remove enrollments from array
      enrollmentsDupe.splice(enrollmentsDupe.indexOf(enrollment), 1)
    }

    const officeHour = officeHours.find((officeHour) => officeHour.sku == lineItem.sku)
    if (!officeHour) {
      console.log(`no office hour found for sku ${lineItem.sku}`, officeHours)
    }
    return OfficeHourSubscription(lineItem, enrollment, officeHour)
  })

  console.log(`${officeHourSubscriptions.length} office hours ${officeHourCountWithoutEnrollment ? '(' + officeHourCountWithoutEnrollment + ' without enrollment)' : ''}`)
  props.onOfficeHours && props.onOfficeHours(officeHourSubscriptions)

  return (
    <OfficeHourSubscriptionsContext.Provider value={officeHourSubscriptions}>
      {props.children}
    </OfficeHourSubscriptionsContext.Provider>
  );
};

export { OfficeHourSubscriptionsContext, OfficeHourSubscriptionsProvider}
